import React from 'react';

const DiscountModal = () => (
  <div className="card p-3">
    <h5>Remises</h5>
    <p className="text-muted mb-0">
      Modal de remise prête à être connectée aux règles métier existantes.
    </p>
  </div>
);

export default DiscountModal;
